import { render, staticRenderFns } from "./getValue.vue?vue&type=template&id=f340b2bc&"
import script from "./getValue.vue?vue&type=script&lang=js&"
export * from "./getValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports